import React from 'react';
import { withRouter } from 'react-router-dom';

import {PrimaryButton} from 'Components/Button';
import {FormHandler, Input, FileUpload} from 'Components/Form';
import {Alert} from 'Components/Partials';

import {User} from 'Services';
import {getFallbackAvatarUrl} from 'Services/AuthHelpers';
import Me from 'Services/Api/Me/Me';

import SettingsPage from '../SettingsPage';

class Profile extends React.Component {
    /**
     * @var success
     * @type {string}
     */
    success = 'Your details have been updated successfully';

    /**
     * @var displayAvatar
     * @type {boolean}
     */
    displayAvatar = false;

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.props.setForm(User.data);

        User.on('change', this.handleSuccess);
    };

    /**
     * @method componentWillUnmount
     * @return {User}
     */
    componentWillUnmount = () => User.removeListener('change', this.handleSuccess);

    /**
     * @method handleSuccess
     * @return {*}
     */
    handleSuccess = () => this.props.history.push('/');

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {form, working, alert, handleInput, getFieldError, handleSubmit} = this.props;

        return (
            <SettingsPage>
                <form
                    className="w-full md:w-2/3 lg:w-1/2 mx-auto"
                    autoComplete="off"
                    onSubmit={(e) => handleSubmit(e, Me.update, this.success)}
                >
                    <div className="p-6">
                        <h1 className="font-aleo text-4xl font-bold text-app-blue-light text-center">
                            About You
                        </h1>
                    </div>

                    <div className="p-6">
                        {alert !== null && (<Alert {...alert} />)}

                        {this.displayAvatar &&
                            <FileUpload
                                containerClassName="m-8 mt-4 flex flex-col justify-center items-center gap-4"
                                value={form.avatar_path}
                                onChange={v => handleInput('avatar_path', v)}
                                accept="image/*"
                                placeholder="Update Picture"
                                fallbackImage={getFallbackAvatarUrl(User.data)}
                            />
                        }

                        <div className="grid grid-cols-1 gap-4 mb-4">
                            <div>
                                <Input
                                    label="First Name"
                                    value={form.first_name}
                                    id="first_name"
                                    error={getFieldError('first_name')}
                                    onChange={(v) => handleInput('first_name', v)}
                                />
                            </div>

                            <div>
                                <Input
                                    label="Last Name"
                                    value={form.last_name}
                                    id="last_name"
                                    error={getFieldError('last_name')}
                                    onChange={(v) => handleInput('last_name', v)}
                                />
                            </div>

                            <div>
                                <Input
                                    label="Email"
                                    value={form.email}
                                    id="email"
                                    error={getFieldError('email')}
                                    onChange={(v) => handleInput('email', v)}
                                    readOnly={!window.base.features.allow_email_change}
                                />
                            </div>

                            <div>
                                <Input
                                    label="Number Of People You're Watching With"
                                    value={form.number_of_people_watching_with}
                                    id="number_of_people_watching_with"
                                    error={getFieldError('number_of_people_watching_with')}
                                    onChange={(v) => handleInput('number_of_people_watching_with', v)}
                                    type="number"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="p-6 flex justify-center">
                        <PrimaryButton
                            text="Save"
                            working={working}
                        />
                    </div>
                </form>
            </SettingsPage>
        );
    }
}

export default FormHandler(withRouter(Profile));
